export default __webpack_public_path__ + "static/media/virtual.9b8e650a.svg";